module.exports = __webpack_public_path__ + "static/media/site-preview.6452059a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/site-preview.jpg
// module id = 361
// module chunks = 0